module.exports = __webpack_public_path__ + "static/media/lfm.325b56c8.png";